import { render } from "./HypothesisAnalysisIcon.vue?vue&type=template&id=1dce679d"
import script from "./HypothesisAnalysisIcon.vue?vue&type=script&lang=js"
export * from "./HypothesisAnalysisIcon.vue?vue&type=script&lang=js"
script.render = render

export default script